import { motion } from 'framer-motion'
import { CheckCircle2 } from 'lucide-react'
import { ContactQRCode } from '@/components/common/ContactQRCode'
import { blockCard } from '@/lib/ui-classes'

export function ContactSection() {
  return (
    <section id="contact-us" className="relative overflow-hidden bg-zinc-950 px-4 py-10 sm:px-6">
      <div className="mx-auto max-w-6xl">
        <div className={`${blockCard} rounded-[2rem] p-8 backdrop-blur-xl md:p-10`}>
          <div className="grid grid-cols-1 items-center gap-10 md:grid-cols-2">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="space-y-8"
            >
              <h2 className="flex flex-col gap-4 text-3xl font-semibold text-white md:text-4xl">
                <span>专业团队为您提供</span>
                <span className="bg-gradient-to-r from-[#07F4F2] to-[#C1FAB8] bg-clip-text text-transparent">
                  定制化解决方案
                </span>
              </h2>

              <div className="space-y-4">
                {['7×24 小时专业技术支持', '1 分钟内快速响应', '企业级安全保障'].map(item => (
                  <div key={item} className="flex items-center gap-3">
                    <CheckCircle2 className="h-6 w-6 text-[#07F4F2]" />
                    <span className="text-lg text-zinc-300">{item}</span>
                  </div>
                ))}
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="flex flex-col items-center justify-center space-y-4"
            >
              <div className="rounded-2xl bg-white p-4 shadow-[0_8px_32px_-8px_rgba(7,244,242,0.25)]">
                <ContactQRCode size={200} className="rounded-lg" />
              </div>
              <p className="text-sm text-zinc-400">微信扫描二维码，与我们联系</p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  )
}
